<form [formGroup]="herkunftsnachweisForm">
    <p translate>
        document.proofOfOriginInfoText
    </p>
    <kendo-formfield class="herkunftsnachweis">
        <kendo-label class="form-label" [for]="herkunftsnachweis" text="{{'document.copyright' | translate }}*"></kendo-label>
        <kendo-textbox #herkunftsnachweis
        formControlName="herkunftsnachweis"
        showSuccessIcon="initial"
        showErrorIcon="initial"
         ></kendo-textbox>
    </kendo-formfield>
</form>
<kendo-dialog-actions>
    <button kendoButton class="cancel-button" (click)="onCancelClick()" translate>
        <i></i>&nbsp;
        document.cancel
    </button>
    <button kendoButton class="confirm-button" (click)="onSaveClick()" [disabled]="isSaveButtonDisabled" translate>
        <i></i>&nbsp;
        document.save
    </button>
</kendo-dialog-actions>